module.exports = __webpack_public_path__ + "img/violet_096.05ebb9aa.png";